export const ROLES = {
  ADMIN: "ROLE_ADMIN",
  ORG_ADMIN: "ROLE_ORG_ADMIN",
};
